<template>
	<button class="button is-danger is-fullwidth" :class="{'is-loading': loading}" @click.prevent="clicked" v-google-signin-button>
		<span class="icon"><font-awesome-icon :icon="['fab','google']" /></span>
		<span v-if="text">{{text}}</span>
	</button>
</template>

<script>
	export default {
		props:{
			text: {
				type: String,
				default: ''
			}
		},
		name: 'GoogleLoginButton',

		data() {
			return {
				loading: false
			};
		},
		methods: {
			clicked(){
				this.loading = true
			},
			onGoogleAuthSuccess(googleUser){
				this.loading = false
				this.$emit('success',googleUser)
			},
			onGoogleAuthFail(error){
				this.loading = false
				this.$emit('error',error)
				//console.log(JSON.stringify(error, undefined, 2));
			}
		},
		directives: {
			'google-signin-button': {
				bind(el, binding, vnode){
					//let clientId = binding.value
					let googleSignInAPI = document.createElement('script')
					googleSignInAPI.setAttribute('src', 'https://apis.google.com/js/platform.js')
					document.head.appendChild(googleSignInAPI)

					googleSignInAPI.onload = InitGoogleButton


					function InitGoogleButton() {
						window.gapi.load('auth2', () => {
							const auth2 = window.gapi.auth2.init()
							auth2.attachClickHandler(el, {},
								OnSuccess,
								OnFail
								)
						})
					}

					function OnSuccess(googleUser){
						vnode.context.onGoogleAuthSuccess(googleUser)
					}
					function OnFail(error){
						vnode.context.onGoogleAuthFail(error)
					}
				}
			}
		}
	};
</script>

<style lang="css" scoped>
</style>
